import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { ReferenceDataOptionLists } from '../constants/reference-data-option-lists';

const inProgressClass = 'in-progress-offer-status';
const alertClass = 'alert-offer-status';
const negativeClass = 'negative-offer-status';
const positiveClass = 'positive-offer-status';

@Directive({
  selector: '[boiCategorizeOfferStatus]'
})
export class CategorizeOfferStatusDirective implements OnInit, OnChanges {
  @Input() offerStatus: string;

  constructor(private readonly hostElement: ElementRef, private readonly renderer: Renderer2) {}

  ngOnInit(): void {
    this.addOfferStatusCssClass();
  }

  ngOnChanges(): void {
    this.addOfferStatusCssClass();
  }

  private addOfferStatusCssClass(): void {
    const categories = {};
    categories[ReferenceDataOptionLists.OnlineOfferStatusCreated.toUpperCase()] = inProgressClass;
    categories[ReferenceDataOptionLists.OnlineOfferStatusPublished.toUpperCase()] = inProgressClass;
    categories[ReferenceDataOptionLists.OnlineOfferStatusError.toUpperCase()] = alertClass;
    categories[ReferenceDataOptionLists.OnlineOfferStatusExpired.toUpperCase()] = negativeClass;
    categories[ReferenceDataOptionLists.OnlineOfferStatusSuperseded.toUpperCase()] = inProgressClass;
    categories[ReferenceDataOptionLists.OnlineOfferStatusPublishingFailed.toUpperCase()] = inProgressClass;
    categories[ReferenceDataOptionLists.ApplicantAcceptanceStatusAccepted.toUpperCase()] = positiveClass;
    categories[ReferenceDataOptionLists.ApplicantAcceptanceStatusViewed.toUpperCase()] = inProgressClass;
    categories[ReferenceDataOptionLists.ApplicantAcceptanceStatusIssued.toUpperCase()] = inProgressClass;

    const cssClass = this.offerStatus
      ? categories[this.offerStatus.toUpperCase()]
        ? categories[this.offerStatus.toUpperCase()]
        : this.offerStatus.toLowerCase()
      : '';

    if (cssClass !== '') {
      if (this.hostElement.nativeElement.className) {
        this.renderer.removeClass(this.hostElement.nativeElement, this.hostElement.nativeElement.className);
      }

      this.renderer.addClass(this.hostElement.nativeElement, cssClass);
    }
  }
}
